import React, { useState } from 'react';

interface LeftSidebarProps {
  open: boolean;
  onToggle: () => void;
  onNavigate?: (path: string) => void;
  activePath?: string;
}

const LeftSidebar: React.FC<LeftSidebarProps> = ({ open = false, onToggle, onNavigate, activePath }) => {
  const [expandedMenus, setExpandedMenus] = useState<string[]>([]);
  const [isHovering, setIsHovering] = useState(false);

  const isExpanded = open || isHovering;

  const toggleSubmenu = (name: string, e: React.MouseEvent) => {
    e.stopPropagation();
    setExpandedMenus(prev =>
      prev.includes(name)
        ? prev.filter(n => n !== name)
        : [...prev, name]
    );
  };

   const menuItems = [
    { name: 'Dashboard', path: '/dashboard', icon: <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z" /></svg> },
    { name: 'Chat', path: '/chat', exact: true, icon: <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" /></svg> },
    { name: 'Code Editor', path: '/editor', icon: <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4" /></svg> },
    { name: 'Knowledgebase', path: '/knowledgebase', icon: <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" /></svg> },
    { name: 'Library', path: '/library', icon: <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" /></svg> },
    { name: 'Projects', path: '/projects', icon: <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z" /></svg> },
    { name: 'Models', path: '/models', icon: <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" /></svg> },
    { name: 'Tasks', path: '/tasks', icon: <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" /></svg> },
    { name: 'Teams', path: '/teams', icon: <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" /></svg> },
    { 
      name: 'Settings', 
      path: '/settings', 
      icon: <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" /></svg>,
      submenu: [
        { name: 'Theme Builder', path: '/settings/theme' },
        { name: 'Appearance', path: '/settings/appearance' },
        { name: 'Preferences', path: '/settings/preferences' }
      ]
    },
  ];

  const userAvatarMenuItem = { 
    name: 'User', 
    path: '/profile', 
    icon: <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" /></svg>,
  };

  return (
    <aside
      onMouseLeave={() => setIsHovering(false)}
       className={`${
         isExpanded ? 'w-64' : 'w-16'
       } transition-all duration-300 border-r border-slate-200 dark:border-border bg-slate-100/70 dark:bg-background overflow-hidden flex-shrink-0 flex flex-col h-full`}
     >
       {/* Sidebar Header */}
       <div className="h-14 border-b border-border flex items-center px-3">
         <button
           onClick={onToggle}
           onMouseEnter={() => setIsHovering(true)}
           className="p-2 rounded-md hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
         >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>
        {open && <span className="ml-3 font-bold text-lg">Mawi</span>}
      </div>

      <nav className="p-2 space-y-1 flex-1">
        {menuItems.map((item, index) => (
          <div key={index}>
            <button
              onClick={() => {
                if (!item.submenu) {
                  onNavigate?.(item.path);
                  // Auto collapse after navigation click
                  if (!open) setIsHovering(false);
                }
              }}
              className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-md hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors text-sm ${isExpanded ? 'justify-start' : 'justify-center'} ${(item.exact && activePath === item.path) || (!item.exact && activePath?.startsWith(item.path)) ? 'bg-gray-100 dark:bg-gray-700' : ''}`}
            >
              <div className="flex items-center gap-3 flex-1">
                {item.icon}
                {isExpanded && <span>{item.name}</span>}
              </div>
              {isExpanded && item.submenu && (
                <div
                  onClick={(e) => toggleSubmenu(item.name, e)}
                  className="ml-auto p-1 rounded hover:bg-gray-200 dark:hover:bg-gray-600 cursor-pointer"
                >
                  <svg className={`w-4 h-4 transition-transform ${expandedMenus.includes(item.name) ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </div>
              )}
            </button>
            {isExpanded && item.submenu && expandedMenus.includes(item.name) && (
              <div className="ml-4 mt-1 space-y-1">
                {item.submenu.map((subitem, subindex) => (
                  <button
                    key={subindex}
                    onClick={() => onNavigate?.(subitem.path)}
                    className={`w-full text-left px-3 py-2 rounded-md hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors text-sm ${activePath === subitem.path ? 'bg-gray-100 dark:bg-gray-700' : ''}`}
                  >
                    {subitem.name}
                  </button>
                ))}
              </div>
            )}
          </div>
        ))}
      </nav>

      {/* Settings Button at Bottom */}
      <div className="p-2 border-t border-gray-200 dark:border-gray-700">
        <div>
          <button
            onClick={() => onNavigate?.(userAvatarMenuItem.path)}
            className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-md hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors text-sm ${isExpanded ? 'justify-start' : 'justify-center'} ${activePath?.startsWith(userAvatarMenuItem.path) ? 'bg-gray-100 dark:bg-gray-700' : ''}`}
          >
            <div className="flex items-center gap-3 flex-1">
              {userAvatarMenuItem.icon}
              {isExpanded && <span>{userAvatarMenuItem.name}</span>}
            </div>
          </button>
        </div>
      </div>
    </aside>
  );
};

export default LeftSidebar;